import { useEffect, useRef } from "react";
import { useAuth } from "@/context/AuthContext";

const IDLE_MS = 30 * 60 * 1000; // 30 min
const EVENTS = ["mousemove", "keydown", "click", "scroll", "touchstart"];

export default function IdleTimeout() {
  const { user, logout } = useAuth();
  const timer = useRef(null);

  useEffect(() => {
    if (!user) return;
    const reset = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(async () => {
        await logout();
        window.location.href = "/login?reason=idle";
      }, IDLE_MS);
    };
    EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, reset));
      if (timer.current) clearTimeout(timer.current);
    };
  }, [user, logout]);
  return null;
}
